module.exports = __webpack_public_path__ + "static/media/barcodeExample.681e0a6f.png";